<template>
  <Popover title="Repetir horário">
    <button
      data-test-id="button-retornarquantidadedeagendamentosrestantes-1"
      type="button"
      class="btn btn-sm btn-default"
      data-role="trigger"
      @click="retornarQuantidadeDeAgendamentosRestantes()"
    >
      <span class="fa fa-repeat" />
    </button>
    <template #popover>
      <div class="row" style="width: 260px">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="input-group input-group-sm">
            <span class="input-group-addon"><strong>Quantidade</strong></span>
            <input
              v-mask="'99'"
              data-test-id="input-auto-2"
              :value="quantidade"
              type="text"
              class="form-control"
              @input="quantidade = maximo10($event.target.value)"
            />
            <div class="input-group-btn">
              <button
                data-test-id="button-auto-3"
                type="button"
                class="btn btn-default dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="fa fa-repeat" /> <span class="caret" />
              </button>
              <ul class="dropdown-menu">
                <li :class="agendamento.repetir.regra === 1 ? 'active' : ''">
                  <a
                    data-test-id="a-atribuirregrarepeticao-4"
                    href="#"
                    @click.prevent="atribuirRegraRepeticao(1)"
                  >
                    Todo(a) {{ dia }}, às {{ hora }}.
                  </a>
                </li>
                <li :class="agendamento.repetir.regra === 2 ? 'active' : ''">
                  <a
                    data-test-id="a-atribuirregrarepeticao-5"
                    href="#"
                    @click.prevent="atribuirRegraRepeticao(2)"
                  >
                    Às {{ hora }}, outros dias da semana.
                  </a>
                </li>
              </ul>
            </div>
            <div class="input-group-btn">
              <button
                data-test-id="button-auto-6"
                :disabled="
                  !agendamento.repetir.regra || agendamento.repetir.regra === 1
                "
                class="btn btn-default btn-sm dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="fa fa-plus" /> <span class="caret" />
              </button>
              <ul class="dropdown-menu">
                <li :class="repetirDia('Segunda') ? '' : 'disabled'">
                  <a
                    data-test-id="a-adicionardiasemana-7"
                    href="#"
                    @click.prevent="adicionarDiaSemana('Segunda')"
                  >
                    Segunda
                  </a>
                </li>
                <li :class="repetirDia('Terça') ? '' : 'disabled'">
                  <a
                    data-test-id="a-adicionardiasemana-8"
                    href="#"
                    @click.prevent="adicionarDiaSemana('Terça')"
                  >
                    Terça
                  </a>
                </li>
                <li :class="repetirDia('Quarta') ? '' : 'disabled'">
                  <a
                    data-test-id="a-adicionardiasemana-9"
                    href="#"
                    @click.prevent="adicionarDiaSemana('Quarta')"
                  >
                    Quarta
                  </a>
                </li>
                <li :class="repetirDia('Quinta') ? '' : 'disabled'">
                  <a
                    data-test-id="a-adicionardiasemana-10"
                    href="#"
                    @click.prevent="adicionarDiaSemana('Quinta')"
                  >
                    Quinta
                  </a>
                </li>
                <li :class="repetirDia('Sexta') ? '' : 'disabled'">
                  <a
                    data-test-id="a-adicionardiasemana-11"
                    href="#"
                    @click.prevent="adicionarDiaSemana('Sexta')"
                  >
                    Sexta
                  </a>
                </li>
                <li :class="repetirDia('Sábado') ? '' : 'disabled'">
                  <a
                    data-test-id="a-adicionardiasemana-12"
                    href="#"
                    @click.prevent="adicionarDiaSemana('Sábado')"
                  >
                    Sábado
                  </a>
                </li>
                <li :class="repetirDia('Domingo') ? '' : 'disabled'">
                  <a
                    data-test-id="a-adicionardiasemana-13"
                    href="#"
                    @click.prevent="adicionarDiaSemana('Domingo')"
                  >
                    Domingo
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div
        v-if="agendamento.repetir.regra === 2"
        class="row"
        style="margin-bottom: 15px"
      >
        <div
          v-for="repeticao in agendamento.repetir.repeticoes"
          :key="repeticao.diaSemana"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        >
          <div
            class="col-xs-6 col-sm-6 col-md-6 col-lg-6"
            style="margin-top: 2px"
          >
            <strong>{{ repeticao.diaSemana }}</strong> às {{ hora }}
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <Longpress
              :value="repeticao"
              :on-confirm="removerDiaRepeticao"
              class="btn btn-default btn-xs pull-right text-danger"
              duration="1"
              pressing-text="Removendo em {$rcounter}"
              action-text="Removido"
            >
              Remover
            </Longpress>
          </div>
        </div>
      </div>
      <div v-if="repeticoesDatas.length" class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 repeticoesTabela">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <td>#</td>
                <td>Data</td>
                <td>Horário</td>
                <td>Remover</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, index) in repeticoesDatas" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ r.data }}</td>
                <td>{{ r.hora }}</td>
                <td>
                  <Longpress
                    :value="r"
                    :on-confirm="removerRepeticao"
                    class="btn btn-default btn-xs"
                    duration="2"
                    pressing-text="{$rcounter}"
                    action-text="!"
                  >
                    <span class="fa fa-trash" />
                  </Longpress>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <p v-if="qtdAgendamentosRestantes > 0">
            <strong>{{ qtdAgendamentosRestantes }}</strong> marcações restantes.
          </p>
          <p v-else-if="qtdAgendamentosRestantes === 0">
            Não existem marcações restantes.
          </p>
          <p v-else class="text-danger">
            <strong>{{ Math.abs(qtdAgendamentosRestantes) }}</strong> marcações
            a mais do limite.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div
            class="btn-group btn-group-sm btn-group-justified"
            role="group"
            aria-label="..."
          >
            <div class="btn-group" role="group">
              <button
                data-test-id="button-limpar-14"
                type="button"
                class="btn btn-sm btn-danger"
                @click="limpar()"
              >
                <span class="fa fa-trash" /> Limpar
              </button>
            </div>
            <div class="btn-group" role="group">
              <button
                data-test-id="button-salvar-15"
                type="button"
                class="btn btn-sm btn-success"
                @click="salvar()"
              >
                <span class="fa fa-check" /> Confirmar
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Popover>
</template>

<script>
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import Longpress from 'vue-longpress'

import Popover from '@/componentes/ui/popover/Popover.vue'
import AgendaServico from '@/servicos/AgendaServico'
import GuiaServico from '@/servicos/GuiaServico'
moment.locale('pt-br')

const agendaServico = new AgendaServico()
const guiaServico = new GuiaServico()
const DIAS_SEMANA_PT = [
  'Domingo',
  'Segunda',
  'Terça',
  'Quarta',
  'Quinta',
  'Sexta',
  'Sábado',
]

export default {
  name: 'AgendamentoRepetir',
  components: { Longpress, Popover },
  directives: { mask: AwesomeMask },
  props: {
    unidade: {
      type: String,
      required: true,
    },
    especialidade: {
      type: String,
      required: true,
    },
    agendamento: {
      type: Object,
      required: true,
    },
    agendas: {
      type: Array,
      required: true,
    },
    hora: {
      type: String,
      required: true,
    },
    data: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      repeticoesDatas: [],
      quantidade: '',
      diasDisponiveis: [],
      qtdAgendamentosRestantes: 0,
      showAccordion: [true, false, false, false, false, false, false],
    }
  },
  computed: {
    dia() {
      return DIAS_SEMANA_PT[moment.utc(this.data).day()]
    },
  },
  watch: {
    quantidade() {
      this.gerarDatas()
    },
  },
  created() {
    this.atribuirRegraRepeticao(1)
  },
  methods: {
    maximo10(valor) {
      if (valor >= 10) {
        return 10
      } else {
        return valor
      }
    },
    limpar() {
      this.repeticoesDatas = []
      this.agendamento.repetir = {
        acabarEm: '',
        regra: 1,
        repeticoes: [],
      }
      this.quantidade = ''
      this.atribuirRegraRepeticao(1)
    },
    salvar() {
      const agendamentos = []

      if (this.repeticoesDatas.length) {
        this.repeticoesDatas.forEach((r) => {
          const horas = r.hora.split(',')
          horas.forEach((h) => {
            const a = {
              paciente: this.agendamento.paciente,
              profissional: this.agendamento.profissional,
              status: 'marcado',
              encaixe: this.agendamento.encaixe,
              unidade: this.unidade,
              especialidade: this.especialidade,
              guia: [...this.agendamento.guia],
              observacao: this.agendamento.observacao,
              data: moment.utc(r.data, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              hora: h.trim(),
            }
            agendamentos.push(a)
          }, this)
        }, this)

        agendaServico.adicionarMultiplos(agendamentos)
      }
    },
    repetirDia(dia) {
      return (
        !this.agendamento.repetir.repeticoes.find((r) => r.diaSemana === dia) &&
        this.agendas.find((a) => a.horarios.dia_semana === dia) &&
        this.diasDisponiveis.find((d) => d === dia)
      )
    },
    removerDiaRepeticao(repeticao) {
      const index = this.agendamento.repetir.repeticoes.indexOf(repeticao)
      this.agendamento.repetir.repeticoes.splice(index, 1)
      this.ordernarRepeticao()
      this.gerarDatas()
    },
    removerRepeticao(repeticao) {
      const index = this.repeticoesDatas.indexOf(repeticao)
      this.repeticoesDatas.splice(index, 1)
    },
    ordernarRepeticao() {
      this.agendamento.repetir.repeticoes.sort((r1, r2) => {
        const d1 = DIAS_SEMANA_PT.indexOf(r1.diaSemana)
        const d2 = DIAS_SEMANA_PT.indexOf(r2.diaSemana)
        return d1 - d2
      })
    },
    adicionarDiaSemana(dia) {
      if (!this.repetirDia(dia)) {
        return
      }

      const horas = []

      if (this.agendamento.repetir.regra === 2) {
        horas.push({
          hora: this.hora,
        })
      }
      this.agendamento.repetir.repeticoes.push({
        diaSemana: dia,
        horas: horas,
      })

      this.ordernarRepeticao()
      this.gerarDatas()
    },
    atribuirRegraRepeticao(regra) {
      this.repeticoesDatas = []
      this.agendamento.repetir.regra = regra

      if (regra === 1) {
        this.agendamento.repetir.repeticoes = [
          {
            diaSemana: this.dia,
            horas: [
              {
                hora: this.hora,
              },
            ],
          },
        ]
      } else if (regra === 2) {
        agendaServico
          .pesquisaDatasFuturasProfissional({
            unidade: this.unidade,
            especialidade: this.especialidade,
            hora: this.agendamento.hora,
            profissional: this.agendamento.profissional._id,
          })
          .then((r) => {
            this.diasDisponiveis = r.diasSemana
          })
      }

      this.ordernarRepeticao()
      this.gerarDatas()
    },
    gerarDatas() {
      if (this.quantidade && this.agendamento.repetir.repeticoes.length) {
        this.processarDatas()
      }
    },
    async pesquisaDatasFuturasProfissional() {
      const promise = new Promise((resolve, reject) => {
        agendaServico
          .pesquisaDatasFuturasProfissional({
            unidade: this.unidade,
            especialidade: this.especialidade,
            hora: this.agendamento.hora,
            profissional: this.agendamento.profissional._id,
          })
          .then((r) => {
            resolve(r)
          })
      })
      return promise
    },
    async gerarDiasFuturosRepeticao(dias) {
      const promise = new Promise((resolve, reject) => {
        agendaServico
          .gerarDiasFuturosRepeticao({
            dias: dias.join(','),
            data: moment.utc(this.agendamento.data).format('DD/MM/YYYY'),
            unidade: this.unidade,
            especialidade: this.especialidade,
            profissional: this.agendamento.profissional._id,
            hora: this.agendamento.hora,
            qtdDias: this.quantidade,
          })
          .then((r) => resolve(r))
      })
      return promise
    },
    async processarDatas() {
      const diasParaGerar = this.agendamento.repetir.repeticoes.reduce(
        (dias, r) => {
          return [...dias, r.diaSemana]
        },
        []
      )
      const diasSeguintes = await this.gerarDiasFuturosRepeticao(diasParaGerar)
      this.repeticoesDatas = []
      if (!Array.isArray(diasSeguintes)) {
        return
      }
      diasSeguintes.forEach((d) => {
        this.repeticoesDatas.push({
          data: moment.utc(d).format('DD/MM/YYYY'),
          hora: this.agendamento.hora,
        })
      })
    },
    retornarQuantidadeDeAgendamentosRestantes() {
      if (this.agendamento.status !== 'pre_agendado') {
        guiaServico
          .retornarQuantidadeDeAgendamentosRestantes(this.agendamento._id)
          .then((r) => {
            this.qtdAgendamentosRestantes = r.quantidadeRestante
          })
      } else {
        this.qtdAgendamentosRestantes = 0
      }
    },
  },
}
</script>

<style scoped>
.repeticoesTabela {
  max-height: 240px;
  margin: 1rem 0;
  overflow: auto;
}
</style>
